import React from "react";
import styles from "./FormRequiredValueIcon.module.scss";

export default function FormRequiredValueIcon(props) {
  const { className } = props;
  return <sup className={`${className} ${styles.required}`}>*</sup>;
}
